<template>
	<div class="result row collapse" v-if="result.horse">
		<div class="small-1 columns text-center serif bold flex-container position">
			<span>{{ result.finish_position }}<sup>{{ positionOrdinal }}</sup></span>
		</div>
		<div class="small-5 columns entry-header left">
			<span class="serif number cloth-{{ result.program_number | numeric }}">
				{{ result.program_number }}
			</span>
			<span class="serif title">{{ result.horse.title }}</span>
		</div>
		<div class="small-2 columns entry-header middle text-right">
			<span v-if="result.win_payoff > 0">{{ result.win_payoff | currency }}</span>
		</div>
		<div class="small-2 columns entry-header middle text-right">
			<span v-if="result.place_payoff > 0">{{ result.place_payoff | currency }}</span>
		</div>
		<div class="small-2 columns entry-header right end text-right">
			<span v-if="result.show_payoff > 0">{{ result.show_payoff | currency }}</span>
		</div>
		<div class="small-11 small-offset-1 medium-5 columns">
			<ul class="information no-bullet key-value">
				<li class="ellipsis" v-if="result.jockey">
					<span class="key inactive uppercase">Jockey /</span>
					<span class="value"><a :href="result.jockey.url">{{ result.jockey.title }}</a></span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import util from './../util'
	export default {
		props: [ 'result' ],
		computed: {
			positionOrdinal () {
				return util.ordinal(this.result.finish_position);
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** Result.vue?237ddaa5
 **/